import * as React from "react";
import { forwardRef } from "react";
const SvgEllipse6 = ({
  title,
  titleId,
  ...props
}, ref) => <svg viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<circle cx={1} cy={1} r={1} fill="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgEllipse6);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMiAyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSIxIiBjeT0iMSIgcj0iMSIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";